import { CabinetFl223SettingsApiService } from '@/services/backend/cabinet/fl223/settings';

export const fl223 = {
    settings: new CabinetFl223SettingsApiService()
};
